<template>
  <v-input hide-details class="input-plan">
    <input type="text"
           v-model="model"
           @keypress="allowOnlyDigits"
           @keyup="formatValue"
           :readonly="readonly"
           class="pa-1" />
    <template #append v-if="editable">
      <v-fade-transition leave-absolute>
        <v-progress-circular
            v-if="saving"
            size="24"
            color="info"
            indeterminate
        />
        <v-btn
            v-else
            small depressed tile
            color="info"
            class="ma-0 py-3"
            :disabled="!touched"
            style="min-width: auto;"
            @click="saveValue">
          <v-icon>save</v-icon>
        </v-btn>
      </v-fade-transition>
    </template>
  </v-input>
</template>

<script>
export default {
  props: {
    value: {
      type: String | Number,
      required: true
    },
    indicator: {
      type: Object,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    editable: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    model: null,
    saving: false,
    touched: false
  }),
  computed: {
    period () {
      return this.$route.params.period
    },
  },
  // watch: {
  //   model (val) {
  //     this.touched = (this.value != val)
  //   }
  // },
  mounted () {
    this.model = this.value
  },
  methods: {
    allowOnlyDigits (event) {
      const charCode = (event.which) ? event.which : event.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 44) {
        event.preventDefault()
        return false
      } else {
        return true
      }
    },
    formatValue () {
      let value = `${this.model}`.trim().replace(',', '.').replace(/[^\d.]/g, '')
      this.model = parseFloat(value)

      if (value.endsWith('.')) {
        this.model += '.'
      }

      if (Number.isNaN(this.model)) {
        this.model = ''
      }

      if (this.model !== this.value) {
        this.touched = true
      }
    },
    async saveValue () {
      this.saving = true
      try {
        await this.$store.dispatch('indicators/saveAward', { period: this.period, indicator: this.indicator, award: this.model })
        this.$emit('update', this.model)
        this.touched = false
        this.$events.$emit('notify', {
          message: 'Плановое значение сохранено',
          type: 'info'
        })
      } catch (error) {
        this.$events.$emit('notify', {
          message: error.message,
          type: 'error'
        })
      }
      this.saving = false
    }
  }
}
</script>

<style>
.input-plan input {
  border: 1px solid gray;
  min-width: 32px;
  max-width: 48px;
}
.input-plan input:read-only {
  border: none;
}
.input-plan .v-input__append-outer {
  margin-top: 0;
  margin-left: 4px;
}
</style>
